import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { csvRow } from '../csv';
import { typeLabel } from './payout-transactions';

dayjs.extend(utc);

// Every row of all three groups, so the file reconciles to the payout on its
// own (spec 2026-09-22 §6). Order ID sits right after Order #, matching the
// table's reading order. Store is kept here even though the table dropped
// it: a spreadsheet reconciles by store, and this file is the one place that
// still has to answer that question. Dates in UTC, like the payouts export
// and like Stripe's own — a spreadsheet has no timezone to read them in.
//
// Escaping and the formula guard come from ../csv.js, shared with
// payouts-export.js so the two can never disagree about what is safe.
const line = (row) =>
  csvRow([
    // The word the table shows, lower-cased: "payout returned" tells a
    // spreadsheet what "adjustment" did not (owner, 2026-10-07).
    row.type ? typeLabel(row).toLowerCase() : '',
    row.orderNumber || '',
    row.orderId || '',
    row.storeName || '',
    row.date ? dayjs.utc(row.date).format('YYYY-MM-DD') : '',
    typeof row.amount === 'number' ? row.amount.toFixed(2) : '',
    row.stripeId || '',
  ]);

export const payoutDetailCsv = (detail) => {
  const rows = [
    ...(detail?.charges || []),
    ...(detail?.refunds || []),
    ...(detail?.adjustments || []),
    // Upcoming only: the manual payouts that went out (owner, 2026-10-07).
    ...(detail?.payouts || []),
  ];
  return ['Type,Order #,Order ID,Store,Date (UTC),Net amount,Stripe id', ...rows.map(line)].join('\n');
};

// An Upcoming group's file names its own arrival date (owner, 2026-09-23).
export const payoutCsvFilename = (payoutId, arrival) =>
  arrival ? `payout-${payoutId}-${arrival}.csv` : `payout-${payoutId}.csv`;
